import { mapState } from 'vuex';
import { AppState } from '@/vuex/store';
import { MassState } from '@/mass/vuex/store';
import { ScheduleRuleState } from '@/rule/vuex/store';
import { Broadcast } from '@/mass/models/Broadcast';
import { Account } from '@/common/models/Account';
import { CustomerFilter } from '@/customer/models/CustomerFilter';
import { ScheduleMsg } from '@/rule/models/ScheduleMsg';
import MassSendMsg from '@/mass/models/MassSendMsg';
import { CustomerState } from '@/customer/vuex/store';
import WxTemplate from '@/rule/models/WxTemplate';
import CustomerRemark from '@/customer/models/CustomerRemark';

export default {
  computed: mapState({
    massState(state: AppState): MassState {
      return state.massState;
    },
    remarks(state: AppState): CustomerRemark[] {
      return state.massState.remarks;
    },
    customerState(state: AppState): CustomerState {
      return state.customerState;
    },
    customerFilter(state: AppState): CustomerFilter {
      return state.customerState.customerFilter;
    },
    scheduleMsg(state: AppState): ScheduleMsg | undefined {
      return state.scheduleRuleState.scheduleRule.scheduleMsg;
    },
    scheduleRuleState(state: AppState): ScheduleRuleState {
      return state.scheduleRuleState;
    },
    massSendMsg(state: AppState): MassSendMsg | undefined {
      return state.massState.massSendMsg;
    },
    broadcast(state: AppState): Broadcast {
      return state.massState.broadcast;
    },
    account(state: AppState): Account {
      return state.accountState.account!;
    },
    wxTemplates(state: AppState): WxTemplate[] {
      return state.scheduleRuleState.wxTemplates;
    },
    props(state: AppState): any[] {
      return state.customerState.props;
    },
  }),
};
